import React from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import AgentsManager from "../../components/customer/AgentsManager";
import styles from "../customers/customer.module.scss";

const MyAccount = () => {
    const userId = localStorage.getItem("userId");

    const breadItems = [{ label: "Home", url: "/" }, { label: "My Account" }];
    const home = { icon: "pi pi-home", url: "/" };

    return (
        <div className={styles.customerPage}>
            <div className={styles.pageHeader}>
                <div>
                    <h2>My Account</h2>
                    <BreadCrumb model={breadItems} home={home} />
                </div>
            </div>

            <div className={styles.cardsGrid}>
                <div className={`${styles.sectionCard} ${styles.fullWidthCard}`}>
                    <AgentsManager userId={userId} />
                </div>
            </div>
        </div>
    );
};

export default MyAccount;
